import React, { useState } from "react";
import { useTheme } from "../../style/theme";
import { IoClose, IoSearchOutline } from "react-icons/io5";
import { TbSettingsShare } from "react-icons/tb";
import {
  FaBuilding,
  FaUmbrellaBeach,
  FaUserClock,
  FaFolder,
  FaStar,
  FaSuitcase,
  FaTasks,
  FaStore,
  FaCode,
  FaUsersCog,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { FaRegAddressCard } from "react-icons/fa6";
import { GoOrganization } from "react-icons/go";
import { PiUmbrella } from "react-icons/pi";
import { LuCalendarCheck } from "react-icons/lu";
import { MdOutlineFilterTiltShift } from "react-icons/md";
import { MdOutlineTimer } from "react-icons/md";
import { SlGraph } from "react-icons/sl";
import { GoFileDirectory } from "react-icons/go";
import { FaRegHandshake } from "react-icons/fa6";
import { SlEnvolopeLetter } from "react-icons/sl";
import { CiPaperplane } from "react-icons/ci";
import { BsListTask } from "react-icons/bs";
import { FaRegSquareCheck } from "react-icons/fa6";
import { LuDatabase } from "react-icons/lu";
import TrialEndModal from "../../components/TrialEndModal";
const Settings = () => {
  const [trialEndOpen, setTrialEndOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const { mode } = useTheme();
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const current = 2;
  const total = 5;

  const percentage = (current / total) * 100;
  let currentOrg = JSON.parse(localStorage.getItem("org"));
  let currenrUser = JSON.parse(localStorage.getItem("user"));
  let currentSubscription = JSON.parse(localStorage.getItem("subscription"));

  const permissions = currentSubscription?.plan?.permission || [];
  console.log(permissions, "orgorgorg");

  const hasPermission = (permissionName) => {
    return permissions.some(
      (permission) =>
        permission.key === permissionName && permission.isPermission
    );
  };

  const modules = [
    {
      name: "Employee Information",
      icon: <GoOrganization className="text-orange-400 text-2xl" />,
      link: "/operations/employee-Information",
    },
    {
      name: "Leave Tracker",
      icon: <PiUmbrella className="text-blue-400 text-2xl" />,
      link: "/operations/leave-Tracker",
    },
    {
      name: "Shifts",
      icon: <MdOutlineFilterTiltShift className="text-blue-400 text-2xl" />,
      link: "/operations/shift",
      permissionKey: "shift",
    },
    {
      name: "Files",
      icon: <GoFileDirectory className="text-blue-400 text-2xl" />,
      link: "/operations/files",
    },
    {
      name: "HR Letters",
      icon: <SlEnvolopeLetter className="text-orange-400 text-2xl" />,
      link: "/operations/hrLetters",
    },
    {
      name: "Travel",
      icon: <CiPaperplane className="text-orange-400 text-2xl" />,
      link: "/operations/travel",
    },
    {
      name: "Tasks",
      icon: <BsListTask className="text-orange-400 text-2xl" />,
      link: "/operations/tasks",
      permissionKey: "project_management",
    },
    {
      name: "General",
      icon: <GoOrganization className="text-orange-400 text-2xl" />,
      link: "/operations/general",
    },
    {
      name: "Marketplace",
      icon: <FaStore className="text-blue-400 text-2xl" />,
      link: "/marketplace",
    },
    {
      name: "Developer Space",
      icon: <FaCode className="text-orange-400 text-2xl" />,
      link: "/developer",
    },
    {
      name: "Manage Accounts",
      icon: <FaUsersCog className="text-orange-400 text-2xl" />,
      link: "/manage-accounts",
    },
  ];

  const filteredRows = modules?.filter((row) =>
    row.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div
      className={`${
        mode === "light" ? "bg-[#f7f9fc]" : "bg-[#141414]"
      } w-[100%] h-full`}
    >
      <div
        className={`flex items-center justify-between border rounded-md p-4 shadow-sm w-full ${
          mode === "light" ? "bg-white" : "bg-transparent"
        }`}
      >
        {/* Left Side */}
        <div className="flex items-center gap-4">
          {/* Icon */}
          <div className="p-{12px} bg-gray-100 flex items-center justify-center rounded-md">
            <img
              src={`${
                process.env.REACT_APP_PRODUCTION_SERVER +
                "/static/" +
                currentOrg?.logo
              }`} // replace this with actual icon path
              alt="icon"
              className="w-8 h-8 object-contain"
            />
          </div>

          {/* Title + Loader */}
          <div>
            <h3
              className={`text-sm font-semibold ${
                mode === "light" ? "text-gray-800" : "text-[#fff]"
              } mb-1`}
            >
              {currentOrg.name}
            </h3>
            <div className="flex items-center gap-2 text-xs text-gray-500">
              <div className="relative w-5 h-5">
                {/* Background circle */}
                <svg className="w-full h-full rotate-[-90deg]">
                  <circle
                    cx="50%"
                    cy="50%"
                    r="8"
                    stroke="#e5e7eb" // Tailwind's gray-200
                    strokeWidth="3"
                    fill="none"
                  />
                  <circle
                    cx="50%"
                    cy="50%"
                    r="8"
                    stroke="#a855f7" // Tailwind's purple-500
                    strokeWidth="3"
                    fill="none"
                    strokeDasharray={`${2 * Math.PI * 8}`}
                    strokeDashoffset={`${
                      2 * Math.PI * 8 * (1 - percentage / 100)
                    }`}
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <span>User License</span>
              <span
                className={`font-bold ${
                  mode === "light" ? "text-gray-800" : "text-[#fff]"
                }`}
              >
                {current}
              </span>
              /<span>{total}</span>
            </div>
          </div>
        </div>

        {/* Right Side */}
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-gray-200 rounded-md flex items-center justify-center">
            <svg
              className="w-5 h-5 text-gray-400"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M12 12c2.7 0 4.5-1.8 4.5-4.5S14.7 3 12 3 7.5 4.8 7.5 7.5 9.3 12 12 12zm0 1.5c-3 0-9 1.5-9 4.5V21h18v-3c0-3-6-4.5-9-4.5z" />
            </svg>
          </div>
          <div className="text-sm">
            <p
              className={`${
                mode === "light" ? "text-gray-800" : "text-[#fff]"
              }`}
            >
              {currenrUser?.firstName} {currenrUser?.lastName}
            </p>
            <p className="text-xs text-gray-500">{currenrUser?.role}</p>
          </div>
        </div>
      </div>

      <div className=" mt-[20px]">
        {isSearchOpen ? (
          <div className="w-full relative">
            <input
              type="text"
              value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search Settings"
              className={`w-full text-[#000] pl-12 pr-8 py-4 border border-blue-500 rounded-md
               outline-none text-sm ${
                 mode === "light"
                   ? "placeholder-gray-400"
                   : "placeholder-transparent"
               }`}
            />
            {/* Search icon (inside input) */}
            <IoSearchOutline
              className={`absolute left-5 top-[18px] text-[#777777]`}
            />
            {/* Close icon */}
            <IoClose
              className={`absolute right-5 top-[18px] text-[#777777] cursor-pointer`}
              onClick={() => {
                setIsSearchOpen(false);
                setSearchValue("");
              }}
            />
          </div>
        ) : (
          <div className="flex justify-end gap-2">
            <div
              className={`${
                mode === "light" ? "bg-[#fff]" : "bg-transparent"
              } p-2 rounded-md cursor-pointer`}
              onClick={() => setIsSearchOpen(true)}
            >
              <IoSearchOutline />
            </div>
            <div
              className={`${
                mode === "light" ? "bg-[#fff]" : "bg-transparent"
              } p-2 rounded-md`}
            >
              <TbSettingsShare />
            </div>
          </div>
        )}
      </div>

      <div className="p-4">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-7 gap-4">
          {filteredRows?.map((mod, idx) => {
            const isAllowed = mod.permissionKey
              ? hasPermission(mod.permissionKey)
              : true;

            const handleModuleClick = (e) => {
              if (!isAllowed) {
                e.preventDefault(); // Stop navigation
                setTrialEndOpen(true);
              }
            };

            return (
              <div key={idx}>
                <Link
                  to={mod.link}
                  onClick={handleModuleClick}
                  className={`flex flex-col items-center justify-center border border-[#d7e2ed] ${
                    mode === "light" ? "bg-white" : "bg-transparent"
                  }
          p-4 rounded-xl shadow-sm hover:shadow-md transition-all text-center`}
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-md mb-2">
                    {mod.icon}
                  </div>
                </Link>
                <p
                  className={`text-sm ${
                    mode === "light" ? "text-[#222222]" : "text-[#fff]"
                  } mt-2 font-[400] text-center`}
                >
                  {mod.name}
                </p>
              </div>
            );
          })}
        </div>
      </div>

      <TrialEndModal
        open={trialEndOpen}
        onClose={() => setTrialEndOpen(false)}
      />
    </div>
  );
};

export default Settings;
